import AddIcon from '@mui/icons-material/Add'

export function AddCircleIcon(props: React.ComponentProps<typeof AddIcon>) {
    return <AddIcon sx={{ border: '2px solid', borderRadius: 15 }} {...props} />
}
